/* tslint:disable */

/**
 */
export class AutoStep {
    ID_STEP?: number;
    ID_AUTO?: number;
    STEP?: number;
    NAME?: string;
    STATUS?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/auto-step.ts